import { render, staticRenderFns } from "./Appointment_Modal.vue?vue&type=template&id=2f5a7864&scoped=true&"
import script from "./Appointment_Modal.vue?vue&type=script&lang=js&"
export * from "./Appointment_Modal.vue?vue&type=script&lang=js&"
import style0 from "./Appointment_Modal.vue?vue&type=style&index=0&id=2f5a7864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5a7864",
  null
  
)

export default component.exports